import React from "react";
import { Box, Container, Typography, Button, Grid, Card, CardMedia } from "@mui/material";
import { motion } from "framer-motion";

import possysVideo from './images/possys.mp4';

const services = [
  {
    type: "Toast POS Implementation",
    description: "Expert hardware installation including terminal mounting, cabling, and network configuration to ensuring your Toast system runs flawlessly.",
    image: "https://storage.googleapis.com/app_darkendimg/data-speedway/cloud-1.png", // Using existing asset or generic
    bg: "#f5f5f5",
  },
  {
    type: "Software Configuration",
    description: "Comprehensive menu building, modifier set creation, and taxation rule configuration. We tailor the software to fit your unique business workflow.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=600&q=80",
    bg: "#212120ff", // Light yellow tint
  },
  {
    type: "Staff Training",
    description: "Hands-on, on-site training sessions for managers and staff. We ensure your team is confident and ready to serve customers from day one.",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=600&q=80",
    bg: "#f9f9f9ff", // Light green tint
  },
  {
    type: "Go-Live Support",
    description: "We stand by your side on launch day. Our support technicians are on-site to troubleshoot issues and assist staff during the critical opening rush.",
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=600&q=80",
    bg: "#2b2929ff",
  },
  {
    type: "Kitchen Efficiency (KDS)",
    description: "Optimize your back-of-house with Kitchen Display Systems. We configure routing and workflows to speed up ticket times and reduce errors.",
    image: "https://images.unsplash.com/photo-1556910103-1c02745a30bf?auto=format&fit=crop&w=600&q=80",
    bg: "#f6f9fbff",
  },
];



const HeroSection = () => (
  <Box
    sx={{
      position: "relative",
      height: { xs: "300px", sm: "400px", md: "500px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      textAlign: "center",
      padding: { xs: 2, sm: 5 },
      overflow: "hidden", // Ensure video doesn't overflow
    }}
  >
    {/* Video Background */}
    <video
      autoPlay
      loop
      muted
      playsInline
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        objectFit: "cover",
        top: 0,
        left: 0,
        zIndex: 0,
      }}
    >
      <source src={possysVideo} type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    {/* Dark Overlay */}
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.6)", // Dark overlay
        zIndex: 1
      }}
    />
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      style={{ zIndex: 2, position: "relative" }}
    >
      <Typography variant="h2" fontWeight="bold">
        Expert POS Services
      </Typography>
      <Typography variant="h5" mt={2} sx={{ color: '#facd00' }}>
        Certified Toast Installers & Software Specialists
      </Typography>
      <Box mt={4}>
        <Button variant="contained" size="large" sx={{ mr: 2, bgcolor: '#facd00', color: 'black', fontWeight: 'bold' }}>
          Get Started
        </Button>
      </Box>
    </motion.div>
  </Box>
);

const ServiceSection = ({ type, description, image, bg, index }) => {
  const isEven = index % 2 === 0;
  return (
    <motion.div
      initial={{ opacity: 0, x: isEven ? -100 : 100 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <Box sx={{ backgroundColor: bg, py: 6 }}>
        <Container>
          <Grid container spacing={4} alignItems="center">
            {isEven ? (
              <>
                <Grid item xs={12} md={6}>
                  <CardMedia component="img" height="300" image={image} sx={{ borderRadius: 2, boxShadow: 3 }} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: 0, borderRadius: 3, p: 3, bgcolor: 'transparent' }}>
                    <Typography variant="h4" fontWeight="bold">
                      {type}
                    </Typography>
                    <Typography variant="h6" mt={2} color="textSecondary">
                      {description}
                    </Typography>
                  </Card>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: 0, borderRadius: 3, p: 3, bgcolor: 'transparent' }}>
                    <Typography variant="h4" fontWeight="bold">
                      {type}
                    </Typography>
                    <Typography variant="h6" mt={2} color="textSecondary">
                      {description}
                    </Typography>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <CardMedia component="img" height="300" image={image} sx={{ borderRadius: 2, boxShadow: 3 }} />
                </Grid>
              </>
            )}
          </Grid>
        </Container>
      </Box>
    </motion.div>
  );
};

const UserPage = () => {
  return (
    <>
      <HeroSection />
      {services.map((service, index) => (
        <ServiceSection key={index} index={index} {...service} />
      ))}
    </>
  );
};

export default UserPage;
